import axios from 'axios';
import { jsonp } from './load';

// 为了理解方便，这里放置 jsonp 的接口暴露
export { jsonp };

/**
 * 创建axios示例并设置通用设置
 */
const http = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    // 这里可以追加认证token

  },
  // 超时默认 10秒
  timeout: 20000
});

/**
 * GET请求
 * @param {String} url 要请求的url地址
 * @param {?Object} params 请求的querystring参数列表 {key:value} 
 */
export function get(url, params) {
  return http({
    url,
    method: 'get',
    params
  }).then(res => res.data);
}

/**
 * POST请求
 * @param {String} url 要请求的url地址
 * @param {?Object} data 请求的body data内容 
 */
export function post(url, data) {
  return http({
    url,
    method: 'post',
    data
  }).then(res => res.data);
}


